import styled from '@emotion/styled'

import { BorderRadius } from '../../../../enums/borderRadius'
import { DefaultValue } from '../../../../enums/defaultValue'
import { Spacing } from '../../../../enums/spacing'
import { Alignment } from '../../../../types/alignment'
import { MODAL_HORIZONTAL_PADDING } from '../../constants/modalHorizontalPadding'
import { Size } from '../../types/size'

const alignmentToJustifyContent: Record<Alignment, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
}

interface ModalFooterWrapperProps {
  alignment: Alignment
  size?: Size
}

export const ModalFooterWrapper = styled.footer<ModalFooterWrapperProps>`
  display: flex;
  justify-content: ${({ alignment }) => alignmentToJustifyContent[alignment]};
  min-height: 72px;
  padding: ${Spacing.S16} ${MODAL_HORIZONTAL_PADDING} ${Spacing.S24};
  border-radius: ${({ size }) =>
    size === 'fullScreen' ? BorderRadius.R0 : `0 0 ${DefaultValue.BorderRadius} ${DefaultValue.BorderRadius}`};
`
